import { useMutation } from '@tanstack/react-query'

import { fetchWithHeaders } from 'utils'

import { GrapeAPIError } from './GrapeAPIError'

interface UseMatchReceiptArgs {
  substantiationId: string
  blobId: string
}

export function useMatchReceipt ({ substantiationId, blobId }: UseMatchReceiptArgs) {
  return useMutation({
    mutationFn: async () => {
      const response = await fetchWithHeaders(
        `/api/web/admin/substantiations/${substantiationId}/match_receipt`,
        {
          method: 'PATCH',
          body: JSON.stringify({ blob_id: blobId }),
        }
      )
      if (!response.ok) {
        const error = await response.json()
        throw GrapeAPIError({
          status: response.status,
          message: error.message ?? 'Failed to match receipt',
          errors: error.errors ?? [],
        })
      }
      return response.json()
    },
  })
}
